<template>
  <v-dialog v-model="dialog" max-width="450">
    <v-card>
      <v-toolbar extended extension-height="10">
        <v-toolbar-title class="primary--text pt-2 font-weight-bold">
          Adicionar alimento
          <div class="secondary--text subtitle-1 font-weight-medium">
            <v-chip small class="rounded-0">{{ visita.lotes[this.$route.params.id_lote].lote }}</v-chip>
          </div>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-6">
        <v-form ref="form">
          <v-combobox
            v-model="dieta.descricao_alimento"
            label="Alimento"
            :items="sugestoesAlimentos"
            hide-no-data
            hide-selected
            :return-object="false"
            clearable            
            :rules="[(v) => !!v || 'Informe o alimento']"
            
          />

          <!-- <v-textarea
            rows="2"
            label="Alimento"
            placeholder="Informe o alimento"
            autofocus
            v-model="dieta.descricao_alimento"
            :rules="[
              (v) => !!v || 'Informe o alimento',
              (v) =>
                (v && v.length >= 3) ||
                'O alimento deve ter ao menos 3 caracteres',
            ]"
          ></v-textarea> -->

          <v-row dense>
            <v-col cols="8">
              <v-text-field
                label="Qtde"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="dieta.qtde"
                :rules="[
                  (v) => !!v || 'Informe a quantidade',
                  (v) =>
                    (!isNaN(v) && Number(v) > 0) ||
                    'Digite um número maior que zero',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                label="Emb"
                :items="configuracoes.dados.embalagens_lotes"
                v-model="dieta.embalagem"
                :rules="[(v) => !!v || 'Selecione uma embalagem']"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false">Cancelar</v-btn>
        <v-btn color="success" class="font-weight-bold" @click="addAlimento()"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("visitaTecnica", ["configuracoes", "visita"]),
    sugestoesAlimentos() {
      const coletados = [];

      const add = (s) => {
        if (typeof s === "string" && s.trim()) coletados.push(s.trim());
      };

      // 1) atual: visita.lotes[].itens[].descricao_alimento
      (this.visita?.lotes || []).forEach((l) =>
        (l?.itens || []).forEach((i) => add(i?.descricao_alimento))
      );

      // 2) histórico: visitas.itens[].lotes[] (várias formas possíveis)
      const V = this.visitas;

      // se for array de visitas
      if (Array.isArray(V)) {
        V.forEach((v) => {
          // v.lotes -> itens -> descricao_alimento
          (v?.lotes || []).forEach((l) => {
            (l?.itens || []).forEach((i) => add(i?.descricao_alimento));
            add(l?.descricao_alimento); // fallback: se o lote já tiver descrição direto
          });
          // v.itens -> lotes -> itens
          (v?.itens || []).forEach((it) => {
            add(it?.descricao_alimento); // fallback
            (it?.lotes || []).forEach((l) => {
              (l?.itens || []).forEach((i) => add(i?.descricao_alimento));
              add(l?.descricao_alimento);
            });
          });
        });
      } else if (V && typeof V === "object") {
        // se for um objeto único: visitas.itens[].lotes[]
        (V?.itens || []).forEach((it) => {
          add(it?.descricao_alimento);
          (it?.lotes || []).forEach((l) => {
            (l?.itens || []).forEach((i) => add(i?.descricao_alimento));
            add(l?.descricao_alimento);
          });
        });
        // também considera visitas.lotes[] se existir
        (V?.lotes || []).forEach((l) => {
          (l?.itens || []).forEach((i) => add(i?.descricao_alimento));
          add(l?.descricao_alimento);
        });
      }

      // dedupe por normalização (case/acento) e conta frequência p/ ordenar
      const norm = (s) =>
        s
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim();

      const freq = new Map(); // norm -> { label, count }
      for (const s of coletados) {
        const n = norm(s);
        if (!n) continue;
        if (!freq.has(n)) freq.set(n, { label: s, count: 0 });
        freq.get(n).count++;
      }

      // ordena por frequência desc, depois alfabético
      return Array.from(freq.values())
        .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
        .map((x) => x.label)
        .slice(0, 50); // limite opcional
    },
  },
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      } else {
        this.dieta.embalagem = this.configuracoes.dados.embalagens_lotes[0];
      }
    },
  },
  data: () => ({
    dialog: false,
    dieta: {
      descricao_alimento: "",
      qtde: '',
      embalagem: "",
    },
  }),
  methods: {
    addAlimento() {
      if (this.$refs.form.validate()) {
        this.dieta.qtde = parseFloat(this.dieta.qtde)
        this.visita.lotes[this.$route.params.id_lote].itens.push(this.dieta);
        this.dialog = false;
      }
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>